const en = require('./en.json')
const es = require('./es.json')
const zh = require('./zh.json')

export { en, es, zh }
